import { FC, useMemo } from 'react'
import { PayCardConfirmPaneButton, PayCardMethodPaneButton } from 'components/features/pfm/Button/FloatingPaneButtons'
import { useFormContext } from 'react-hook-form'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { currentCCLedgerSelector } from 'components/features/creditCard/creditCardStore/selectors'
import { getLocalTimeZone, parseDate } from '@internationalized/date'
import moment from 'moment'
import { formatUSDate } from 'helpers/dateTimeHelpers'
import Flex from 'components/atoms/Flex/Flex'
import { RadioButton } from 'components/atoms/inputs/RadioButton/RadioButton'
import { CCCreateAutoPaymentApiRequest } from 'components/features/creditCard/creditCardStore/types'

const PayCardDateStep: FC<{}> = () => {
  const { watch, getFieldState } = useFormContext<CCCreateAutoPaymentApiRequest>()
  const ledger = useStoreSelector(currentCCLedgerSelector)
  const dueDate = !!ledger?.payment_due_date ? parseDate(ledger.payment_due_date) : null
  const normalizedDate = dueDate?.toDate(getLocalTimeZone())
  const displayDate = formatUSDate(moment(normalizedDate), 'Do')
  const paymentMethod = watch('payment_method')
  const methodField = getFieldState('payment_method')
  const methodAlreadySelected = !!paymentMethod && methodField.isTouched

  const SubmitButton = useMemo(() => methodAlreadySelected ? (
    <PayCardConfirmPaneButton text='Save Payment Date' />
  ) : (
    <PayCardMethodPaneButton text='Save Payment Date' />
  ), [methodAlreadySelected])
  return (
    <Flex padding='large-responsive'>
      <section>
        <h2>Choose a monthly payment date</h2>
        <p>
          Your payment due date is the <strong>{ displayDate }</strong> of every month.
        </p>
      </section>
      <fieldset>
        {
          [2, 5, 7, 15].map((option: number, idx: number) => (
            <RadioButton
              name='days_before_due_date'
              key={ idx }
              value={ option }
              label={ option + ' days before each due date' }
              withBorder
            />
          ))
        }
        <small>Payment received after 6PM PT will be submitted on the following business day. For payment days that fall on a weekend or holiday, payments will be submitted on the following business day.</small>
      </fieldset>
      { SubmitButton }
      <small>
        To learn more about your payment due date, minimum payments and
        cancelations, please see the Consumer Credit Card Agreement.
      </small>
    </Flex>
  )
}

export default PayCardDateStep
